import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteCampusModal extends Component {
    handleDelete = async () => {
        const {
            campusSites,
            deleteCampus,
            deleteCampusSites,
            selectedClient,
            selectedNode
        } = this.props;

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            await deleteCampusSites(selectedNode, campusSites, selectedClient);
            isDeleted = await deleteCampus(selectedNode.id, selectedClient.id);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                confirmText="Delete"
            >
                <p>
                    Are you sure you want to delete Campus: {selectedNode.name}?
                </p>
            </EsmsDialog>
        );
    }
}

DeleteCampusModal.defaultProps = {
    selectedClient: {},
    selectedNode:   {}
};

DeleteCampusModal.propTypes = {
    close:          func.isRequired,
    open:           bool.isRequired,
    selectedClient: object,
    selectedNode:   object,
    title:          string.isRequired
};

const mapStateToProps = state => {
    return {
        campusSites:    state.architect.campusSites,
        companyInfo:    state.companyInfo,
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedClient: state.client.selectedClient,
        selectedNode:   state.architect.selectedNode
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCampusModal);
